import { InputWithLabel } from '@adotel/components'
import { RadioGroup, FormControlLabel, Radio } from '@material-ui/core'

import {
  allowedEmailRegex,
  elevenNumbersOnlyRegex,
  englishRegex,
  iranMobileRegex,
  persianLetterRegex,
  persianRegex,
  strictEmailFormatRegex,
  tenNumbersOnlyRegex
} from '../../../../helpers/regex'
import { getTranslate } from '../../../../localization'
import { ConfirmPrimitiveReservationInput } from '../../../../types/cart'
import { validateIdentificationNo } from '../helpers/helper'
import { useStyles } from './styles/index.styles'

type FormProps = {
  confirmPrimitiveInput: ConfirmPrimitiveReservationInput
  setConfirmPrimitiveInput: React.Dispatch<
    React.SetStateAction<ConfirmPrimitiveReservationInput>
  >
  roomIndex: number
  profileIndex: number
}

const Form = ({
  confirmPrimitiveInput,
  setConfirmPrimitiveInput,
  roomIndex,
  profileIndex
}: FormProps) => {
  const classes = useStyles()
  return (
    <div className={classes.formContainer}>
      <RadioGroup
        row
        value={
          confirmPrimitiveInput.confirmRooms[roomIndex].profiles[profileIndex]
            .isForeigner
            ? 'Foreign'
            : 'Iranian'
        }
        onChange={(event) => {
          const isForeign = event.target.value === 'Foreign'

          setConfirmPrimitiveInput({
            ...confirmPrimitiveInput,
            confirmRooms: [
              ...confirmPrimitiveInput.confirmRooms.slice(0, roomIndex),
              {
                ...confirmPrimitiveInput.confirmRooms[roomIndex],
                profiles: [
                  ...confirmPrimitiveInput.confirmRooms[
                    roomIndex
                  ].profiles.slice(0, profileIndex),
                  {
                    ...confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                      profileIndex
                    ],
                    isForeigner: isForeign
                  },
                  ...confirmPrimitiveInput.confirmRooms[
                    roomIndex
                  ].profiles.slice(profileIndex + 1)
                ]
              },
              ...confirmPrimitiveInput.confirmRooms.slice(roomIndex + 1)
            ]
          })
        }}>
        <FormControlLabel
          value="Iranian"
          control={
            <Radio
              color="primary"
              size="small"
              classes={{
                root: classes.radioIcon
              }}
            />
          }
          label={getTranslate('Iranian Guest')}
          classes={{ label: classes.label }}
        />
        <FormControlLabel
          value="Foreign"
          control={
            <Radio
              color="primary"
              size="small"
              classes={{
                root: classes.radioIcon
              }}
            />
          }
          label={getTranslate('Foreign Guest')}
          classes={{ label: classes.label }}
        />
      </RadioGroup>
      <div className={classes.row}>
        <InputWithLabel
          name="firstName"
          autoComplete="given-name"
          label={getTranslate('First Name')}
          error={
            confirmPrimitiveInput.confirmRooms[roomIndex].profiles[profileIndex]
              .firstName.length > 0 &&
            !(confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
              profileIndex
            ].isForeigner
              ? englishRegex.test(
                  confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                    profileIndex
                  ].firstName
                )
              : persianLetterRegex.test(
                  confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                    profileIndex
                  ].firstName
                ))
          }
          helpertext={
            !(confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
              profileIndex
            ].isForeigner
              ? englishRegex.test(
                  confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                    profileIndex
                  ].firstName
                )
              : persianLetterRegex.test(
                  confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                    profileIndex
                  ].firstName
                )) &&
            confirmPrimitiveInput.confirmRooms[roomIndex].profiles[profileIndex]
              .firstName.length > 0
              ? confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                  profileIndex
                ].isForeigner
                ? getTranslate(
                    'Only English letters are allowed for foreign guests'
                  )
                : getTranslate('Just Enter Persian Letters')
              : ''
          }
          className={classes.input}
          value={
            confirmPrimitiveInput.confirmRooms[roomIndex].profiles[profileIndex]
              .firstName
          }
          onChange={(e) => {
            const value = e.currentTarget.value

            setConfirmPrimitiveInput({
              ...confirmPrimitiveInput,
              confirmRooms: [
                ...confirmPrimitiveInput.confirmRooms.slice(0, roomIndex),
                {
                  ...confirmPrimitiveInput.confirmRooms[roomIndex],
                  profiles: [
                    ...confirmPrimitiveInput.confirmRooms[
                      roomIndex
                    ].profiles.slice(0, profileIndex),
                    {
                      ...confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                        profileIndex
                      ],
                      firstName: value
                    },
                    ...confirmPrimitiveInput.confirmRooms[
                      roomIndex
                    ].profiles.slice(profileIndex + 1)
                  ]
                },
                ...confirmPrimitiveInput.confirmRooms.slice(roomIndex + 1)
              ]
            })
          }}
        />
        <InputWithLabel
          label={getTranslate('Last Name')}
          value={
            confirmPrimitiveInput.confirmRooms[roomIndex].profiles[profileIndex]
              .lastName
          }
          className={classes.input}
          error={
            confirmPrimitiveInput.confirmRooms[roomIndex].profiles[profileIndex]
              .lastName.length > 0 &&
            !(confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
              profileIndex
            ].isForeigner
              ? englishRegex.test(
                  confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                    profileIndex
                  ].lastName
                )
              : persianLetterRegex.test(
                  confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                    profileIndex
                  ].lastName
                ))
          }
          helpertext={
            !(confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
              profileIndex
            ].isForeigner
              ? englishRegex.test(
                  confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                    profileIndex
                  ].lastName
                )
              : persianLetterRegex.test(
                  confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                    profileIndex
                  ].lastName
                )) &&
            confirmPrimitiveInput.confirmRooms[roomIndex].profiles[profileIndex]
              .lastName.length > 0
              ? confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                  profileIndex
                ].isForeigner
                ? getTranslate(
                    'Only English letters are allowed for foreign guests'
                  )
                : getTranslate('Just Enter Persian Letters')
              : ''
          }
          onChange={(e) => {
            const value = e.currentTarget.value

            setConfirmPrimitiveInput({
              ...confirmPrimitiveInput,
              confirmRooms: [
                ...confirmPrimitiveInput.confirmRooms.slice(0, roomIndex),
                {
                  ...confirmPrimitiveInput.confirmRooms[roomIndex],
                  profiles: [
                    ...confirmPrimitiveInput.confirmRooms[
                      roomIndex
                    ].profiles.slice(0, profileIndex),
                    {
                      ...confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                        profileIndex
                      ],
                      lastName: value
                    },
                    ...confirmPrimitiveInput.confirmRooms[
                      roomIndex
                    ].profiles.slice(profileIndex + 1)
                  ]
                },
                ...confirmPrimitiveInput.confirmRooms.slice(roomIndex + 1)
              ]
            })
          }}
        />
        <InputWithLabel
          name="email"
          autoComplete="email"
          label={getTranslate('Email')}
          error={
            !strictEmailFormatRegex.test(
              confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                profileIndex
              ].email
            ) &&
            confirmPrimitiveInput.confirmRooms[roomIndex].profiles[profileIndex]
              .email.length > 0
          }
          value={
            confirmPrimitiveInput.confirmRooms[roomIndex].profiles[profileIndex]
              .email
          }
          helpertext={
            !strictEmailFormatRegex.test(
              confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                profileIndex
              ].email
            ) &&
            confirmPrimitiveInput.confirmRooms[roomIndex].profiles[profileIndex]
              .email
              ? getTranslate(
                  'Email address must contain only English letters, numbers, and have a valid format.'
                )
              : ''
          }
          className={classes.input}
          onChange={(e) => {
            const value = e.currentTarget.value

            // Check allowed characters first
            if (!allowedEmailRegex.test(value)) return

            setConfirmPrimitiveInput({
              ...confirmPrimitiveInput,
              confirmRooms: [
                ...confirmPrimitiveInput.confirmRooms.slice(0, roomIndex),
                {
                  ...confirmPrimitiveInput.confirmRooms[roomIndex],
                  profiles: [
                    ...confirmPrimitiveInput.confirmRooms[
                      roomIndex
                    ].profiles.slice(0, profileIndex),
                    {
                      ...confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                        profileIndex
                      ],
                      email: value
                    },
                    ...confirmPrimitiveInput.confirmRooms[
                      roomIndex
                    ].profiles.slice(profileIndex + 1)
                  ]
                },
                ...confirmPrimitiveInput.confirmRooms.slice(roomIndex + 1)
              ]
            })
          }}
        />
      </div>
      <div className={classes.row2}>
        <InputWithLabel
          name="phone"
          autoComplete="tel"
          label={getTranslate('Mobile')}
          type="number"
          min={0}
          onKeyDown={(e) => {
            if (e.key === '-' || e.key === 'e' || e.key === '.') {
              e.preventDefault()
            }
          }}
          placeholder={getTranslate('Type only numbers')}
          className={[classes.input, classes.inputNumber].join(' ')}
          value={
            confirmPrimitiveInput.confirmRooms[roomIndex].profiles[profileIndex]
              .mobile
          }
          error={
            confirmPrimitiveInput.confirmRooms[roomIndex].profiles[profileIndex]
              .mobile.length > 0 &&
            !iranMobileRegex.test(
              confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                profileIndex
              ].mobile
            )
          }
          helpertext={
            confirmPrimitiveInput.confirmRooms[roomIndex].profiles[profileIndex]
              .mobile.length > 0 &&
            !iranMobileRegex.test(
              confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                profileIndex
              ].mobile
            )
              ? getTranslate('Please enter a valid phone numbers')
              : ''
          }
          onChange={(e) => {
            const rawValue = e.currentTarget.value
            if (elevenNumbersOnlyRegex.test(rawValue)) {
              setConfirmPrimitiveInput({
                ...confirmPrimitiveInput,
                confirmRooms: [
                  ...confirmPrimitiveInput.confirmRooms.slice(0, roomIndex),
                  {
                    ...confirmPrimitiveInput.confirmRooms[roomIndex],
                    profiles: [
                      ...confirmPrimitiveInput.confirmRooms[
                        roomIndex
                      ].profiles.slice(0, profileIndex),
                      {
                        ...confirmPrimitiveInput.confirmRooms[roomIndex]
                          .profiles[profileIndex],
                        mobile: rawValue
                      },
                      ...confirmPrimitiveInput.confirmRooms[
                        roomIndex
                      ].profiles.slice(profileIndex + 1)
                    ]
                  },
                  ...confirmPrimitiveInput.confirmRooms.slice(roomIndex + 1)
                ]
              })
            }
          }}
        />
        <InputWithLabel
          label={getTranslate(
            `${
              confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                profileIndex
              ].isForeigner
                ? 'Passport Number'
                : 'ID Card Number'
            }`
          )}
          type={
            confirmPrimitiveInput.confirmRooms[roomIndex].profiles[profileIndex]
              .isForeigner
              ? 'text'
              : 'number'
          }
          min={0}
          onKeyDown={(e) => {
            if (
              e.key === '-' ||
              e.key === '_' ||
              e.key === 'e' ||
              e.key === '+' ||
              e.key === '.' ||
              persianRegex.test(e.key)
            ) {
              e.preventDefault()
            }
          }}
          placeholder={getTranslate('Type only numbers')}
          error={
            confirmPrimitiveInput.confirmRooms[roomIndex].profiles[profileIndex]
              .identificationNo.length > 0 &&
            !validateIdentificationNo(
              confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                profileIndex
              ].identificationNo.slice(0, 10),
              confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                profileIndex
              ].isForeigner
            )
          }
          helpertext={
            confirmPrimitiveInput.confirmRooms[roomIndex].profiles[profileIndex]
              .identificationNo.length > 0 &&
            !validateIdentificationNo(
              confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                profileIndex
              ].identificationNo.slice(0, 10),
              confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                profileIndex
              ].isForeigner
            )
              ? confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                  profileIndex
                ].isForeigner
                ? getTranslate(
                    'Please enter a valid passport number (6–9 alphanumeric).'
                  )
                : getTranslate('The national ID must be 10 digits and valid.')
              : ''
          }
          className={[classes.input, classes.inputNumber].join(' ')}
          value={
            confirmPrimitiveInput.confirmRooms[roomIndex].profiles[profileIndex]
              .identificationNo
          }
          onChange={(event) => {
            const rawInput = event.currentTarget.value
            const inputValue = rawInput.replace(/\s+/g, '')

            if (
              (tenNumbersOnlyRegex.test(inputValue) ||
                confirmPrimitiveInput.confirmRooms[roomIndex].profiles[
                  profileIndex
                ].isForeigner) &&
              inputValue.length <= 10
            ) {
              setConfirmPrimitiveInput({
                ...confirmPrimitiveInput,
                confirmRooms: [
                  ...confirmPrimitiveInput.confirmRooms.slice(0, roomIndex),
                  {
                    ...confirmPrimitiveInput.confirmRooms[roomIndex],
                    profiles: [
                      ...confirmPrimitiveInput.confirmRooms[
                        roomIndex
                      ].profiles.slice(0, profileIndex),
                      {
                        ...confirmPrimitiveInput.confirmRooms[roomIndex]
                          .profiles[profileIndex],
                        identificationNo: event.currentTarget.value
                      },
                      ...confirmPrimitiveInput.confirmRooms[
                        roomIndex
                      ].profiles.slice(profileIndex + 1)
                    ]
                  },
                  ...confirmPrimitiveInput.confirmRooms.slice(roomIndex + 1)
                ]
              })
            }
          }}
        />
      </div>
    </div>
  )
}

export default Form
